export default __webpack_public_path__ + "static/media/class-passes.6ef262ff.svg";